import { render, staticRenderFns } from "./login_external.vue?vue&type=template&id=8987f426"
import script from "./login_external.vue?vue&type=script&lang=ts"
export * from "./login_external.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports